<app-stepper-container [isAllowedToNavigate]=true>

    <app-stepper title="1. Depots"  [isProgress]='isDepotsInProgress'>
          <app-carrier-depot-list  [isInStepper]="true" (nextStepEmitter)="goNext()" ></app-carrier-depot-list>
    </app-stepper>

    <app-stepper title="2. Drivers" [isProgress]='isDriverInProgress'>
        <app-carrier-driver-list [isInStepper]="true" (nextStepEmitter)="goNext()"  (prevStepEmitter)="prevStep()"></app-carrier-driver-list>
    </app-stepper>

    <app-stepper title="3. Vehicles" [isProgress]='isDriverInProgress'>
        <app-manage-vehicles [isInStepper]="true" [stepperCarrierId]="carrierId" (prevStepEmitter)="prevStep()" (nextStepEmitter)="goNext()" style="width: 1200px;"></app-manage-vehicles>
    </app-stepper>

    <app-stepper title="4. Questionnaire" [isProgress]='isQuestionnaireInProgress'>
        <app-questionnaire [isInStepper]="true" (prevStepEmitter)="prevStep()" (nextStepEmitter)="goNext()"></app-questionnaire>
    </app-stepper>

</app-stepper-container>
